import { Suspense, useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Bot, useBotMethods, getRobot, isRobotCollaborator } from '@mygpt/app';

import FallBack from '@/components/SuspenseFallBack';
import { AssistRoutes } from '@/routes';
import { useGPTStore } from '@/store';

const AssistPage = () => {
  const { id } = useParams();
  Bot.setDefaultBotId(id);
  const { clearBot, setBotId } = useBotMethods();
  const { resetRobotInfo, setRobotInfo, userInfo, assetScope } = useGPTStore();
  const isLocalMode = import.meta.env.VITE_MODE === 'local';
  const isCloudEnterprise = !isLocalMode && !!assetScope;
  // Cloud个人模式需要校验权限，校验期间不渲染页面内容
  const needPermissionCheck = !isLocalMode && !isCloudEnterprise;
  const [permissionChecked, setPermissionChecked] = useState(!needPermissionCheck);

  useLayoutEffect(() => {
    id && setBotId(id);
    id &&
      getRobot({ aiId: id }).then(async (res) => {
        setRobotInfo(res.data);
        // Cloud个人模式下，assist页面需要校验权限：非owner需要是协作者才能访问
        if (userInfo && needPermissionCheck) {
          const isOwner = res.data.user.user_id === userInfo.user_id;
          if (isOwner) {
            window.location.replace(window.location.href.replace('/assist/', '/bot/'));
            return;
          }
          const collaboratorResult = await isRobotCollaborator({ aiId: id });
          if (!collaboratorResult.data) {
            window.location.replace('/no-access');
            return;
          }
        }
        setPermissionChecked(true);
      });

    return () => {
      resetRobotInfo();
      clearBot();
      Bot.delDefaultBotId();
    };
  }, [clearBot, id, setBotId]);

  if (!permissionChecked) {
    return <FallBack />;
  }

  return (
    <Suspense fallback={<FallBack />}>
      <AssistRoutes />
    </Suspense>
  );
};

export default AssistPage;
